// state for the geo page
import appData from '@/helpers/app-data'

const geoData = appData.get('geo') || {}

const state = {
  errors: geoData.errors,
  stats: geoData.stats,
  initialBounds: geoData.initial_bounds,
  serviceTypeGroup: geoData.service_type_group,
  serviceType: geoData.service_type,
  geoBrowser: geoData.geo_browser,
  stBrowser: geoData.st_browser,

  // number of incomplete XHRs
  xhrCount: 0 // TODO this could be moved to a general global store
}

const mutations = {
  SET_SERVICE_TYPE_AND_GROUP (state, options) {
    state.serviceTypeGroup = options.stg
    state.serviceType = options.st
  },
  UPDATE_STATS (state, stats) {
    state.stats.userCounter = stats.userCounter
    state.stats.providerCounters = stats.providerCounters
    state.stats.payments = stats.payments
  },
  UPDATE_GEO_BROWSER (state, updatedBrowser) {
    const browser = state.geoBrowser
    let bc = browser.bread_crumbs
    bc.splice(0, bc.length)
    bc.push.apply(bc, updatedBrowser.bread_crumbs)

    const nearby = browser.nearby
    nearby.cities = updatedBrowser.nearby.cities
    nearby.counties = updatedBrowser.nearby.counties
    nearby.cbsas = updatedBrowser.nearby.cbsas
    nearby.states = updatedBrowser.nearby.states
  },
  UPDATE_ST_BROWSER (state, response) {
    state.stBrowser = response.st_browser
  },
  INCREASE_XHR_COUNT (state) {
    state.xhrCount++
  },
  DECREASE_XHR_COUNT (state) {
    state.xhrCount--
  }
}

const actions = {
  setServiceTypeAndGroup ({commit}, options) {
    commit('SET_SERVICE_TYPE_AND_GROUP', options)
  },
  updateStats ({commit}, stats) {
    commit('UPDATE_STATS', stats)
  },
  updateGeoBrowser ({commit}, geoBrowser) {
    commit('UPDATE_GEO_BROWSER', geoBrowser)
  },
  updateStBrowser ({commit}, stBrowser) {
    commit('UPDATE_ST_BROWSER', stBrowser)
  },
  increaseXhrCount ({commit}) {
    commit('INCREASE_XHR_COUNT')
  },
  decreaseXhrCount ({commit}) {
    commit('DECREASE_XHR_COUNT')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./frontend/src/store/modules/geo/index.js